import React, { Component } from "react";
import { connect } from "react-redux";

class DutyTax extends Component {
  render() {
    const { dutyTax } = this.props;
    return <>{dutyTax.deliveryDate && <span>({dutyTax.deliveryDate})</span>}</>;
  }
}

const mapStateToProps = state => ({
  dutyTax: state.countryList.dutyTax
});

const mapDispatchToProps = {};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(DutyTax);
